<template>
	<vx-card style="width: 50vw">
		<div class="vx-col">
			<div class="vx-row">
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<h3>Modifier un prestataire</h3>
				</div>
				<div class="vx-col sm:w-1/2 w-full mb-2">
					<vs-button
						class="float-right"
						radius
						color="primary"
						type="filled"
						icon-pack="feather"
						icon="icon-x"
						@click="returnPrevRoute"
					></vs-button>
				</div>
			</div>
			<div class="vx-row mt-5">
				<!-- Society Name -->
				<div class="vx-col w-1/2">
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="domain" size="small"></vs-icon
								></span>
							</div>
						</template>
						<vs-input
							class="w-full"
							placeholder="Societé"
							v-model="provider.society"
							:style="styleValidator('society')"
							@change="validateOne(provider.society, 'society')"
						/>
					</vx-input-group>
					<vx-tooltip
						v-if="validators['society'] && validators['society'].errText !== ''"
						:text="errText('society')"
						class="ml-3"
					>
						<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
					</vx-tooltip>
				</div>
				<!-- Society Website -->
				<div class="vx-col w-1/2 flex">
					<vx-input-group class="w-full bottom">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="language" size="small"></vs-icon
								></span>
							</div>
						</template>

						<vs-input
							v-model="provider.website"
							placeholder="Site web"
							@change="checkWebsite"
							:danger="
								ProviderValidationObjects.websiteValidationObject.notValid
							"
							:danger-text="
								ProviderValidationObjects.websiteValidationObject.errText
							"
						/>
					</vx-input-group>
					<!-- /WEBSITE -->
				</div>
			</div>

			<div class="vx-row">
				<!-- Tags -->
				<div class="vx-col w-1/3 flex">
					<vx-input-group class="inlineB bottom w-full">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="flex"
									><vs-icon icon="domain" size="small"></vs-icon>*</span
								>
							</div>
						</template>
						<vue-tags
							class="w-full"
							placeholder="Tags"
							:active="selectedTags"
							:all="listDomaine"
							:tag-creation-enabled="true"
							tag-list-label=""
							@on-tag-added="onTagAdded($event)"
							@on-tag-removed="onTagRemoved($event)"
							@on-tag-created="onTagAdded($event)"
							@on-tag-list-opened="
								tagStyle = 'z-index: 1 !important; overflow: visible;'
							"
							@on-tag-list-closed="
								tagStyle = 'z-index: 1 !important; overflow: auto;';
								validateOne(society.activity_domain, 'activity_domain');
							"
							:style="tagStyle"
						>
						</vue-tags>
						<template slot="append">
							<vx-tooltip
								v-if="
									validators['activity_domain'] &&
									validators['activity_domain'].errText !== ''
								"
								:text="errText('activity_domain')"
								class="ml-3"
								style="display: inline-block"
							>
								<vs-icon
									icon="error"
									size="medium"
									style="color: red"
								></vs-icon>
							</vx-tooltip>
						</template>
					</vx-input-group>
				</div>
				<!-- Types -->
				<div class="vx-col w-1/3 flex">
					<vs-select
						style="width: calc(50% + 18px)"
						:name="Math.random()"
						v-model="provider.type"
						class="w-full mt-8 select-large"
						autocomplete
						placeholder="Type"
						id="select-control-width"
					>
						<vs-select-item
							:key="index"
							:value="item.id"
							:text="item.type"
							v-for="(item, index) in providerTypes"
							class="w-full"
						/>
					</vs-select>
				</div>
				<!-- Notes -->
				<div class="vx-col w-1/3 mt-3">
					<p>Note du prestataie</p>
					<star-rating :star-size="20" v-model="provider.rate"></star-rating>
				</div>
			</div>
			<div class="w-full mt-10">
				<!-- Status -->
				<label for="select-control-width">Statut</label>
				<vs-select
					:name="Math.random()"
					v-model="provider.status"
					class="w-full select-large"
					autocomplete
					placeholder="Statut"
					id="select-control-width"
				>
					<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.name"
						v-for="(item, index) in getProvidersStatus()"
						class="w-full"
					/>
				</vs-select>
			</div>
			<div class="vx-row mt-10">
				<div class="vx-col w-2/3 mt-3">
					<span><b>Expertises</b></span>
					<div class="vx-row">
						<div class="vx-col w-full mb-2" v-if="providerTempOptions">
							<span v-for="chip in providerTempOptions" :key="chip.value">
								<vs-chip @click="removeChip(chip)" closable>
									{{ chip.text }}
								</vs-chip>
							</span>
						</div>
					</div>
					<div class="vx-row">
						<div class="vx-col w-full">
							<!-- TEST -->
							<vue-simple-suggest
								class="w-full"
								pattern="\w+"
								v-model.lazy="provider.service_id"
								:list="getExpertiseOptionsList"
								:max-suggestions="10"
								:min-length="1"
								:debounce="200"
								:filter-by-query="true"
								:prevent-submit="true"
								mode="input"
								:nullable-select="true"
								ref="suggestComponent"
								placeholder="Ajoutez une expertise..."
								value-attribute="value"
								display-attribute="text"
								@select="selectExpertise"
							>
								<template slot="misc-item-above" slot-scope="{ suggestions }">
									<template v-if="suggestions.length <= 0"> </template>
								</template>

								<div
									slot="suggestion-item"
									slot-scope="scope"
									:title="scope.suggestion.description"
								>
									<div class="text">
										<span v-html="boldenSuggestion(scope)"></span>
									</div>
								</div>
							</vue-simple-suggest>
							<div v-if="checkExpertiseInList()" class="mt-2">
								<vs-button
									color="primary"
									type="filled"
									@click="addNewExpertise()"
								>
									Ajouter nouvelle expertise
								</vs-button>
							</div>
							<!-- /TEST -->
						</div>
					</div>
				</div>
				<div class="w-1/3">
					<vs-input
						type="number"
						v-model="provider.refund"
						label="Remise négociée %"
						class="mb-0 md:mt-10 mt-6"
						rows="3"
					/>
				</div>
			</div>

			<div class="w-full">
				<div class="vx-col w-full mb-2">
					<vs-textarea
						v-model="provider.commentary"
						label="Commentaire"
						class="mb-0 md:mt-10 mt-6"
						rows="3"
					/>
				</div>
			</div>

			<div class="vx-row right_element">
				<div class="vx-col">
					<!-- <vs-button
            color="warning"
            type="border"
            class="mb-2 mr-3"
            @click="resetForm(provider)"
            >Réinitialiser</vs-button
          > -->
					<vs-button class="mb-2 mt-5" @click="formSubmitted"
						>Enregistrer</vs-button
					>
				</div>
			</div>
		</div>
	</vx-card>
</template>

<script>
import StarRating from "vue-star-rating";
import Provider from "@/entities/Provider";
import Validator from "@/entities/Validator";
import { Service } from "@/entities/Service";
import { ProvidersServices } from "@/entities/ProvidersServices";
import utilsMixin from "@/mixins/utilsMixin";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import validatorMixin from "@/mixins/validatorMixin";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";
import { VueTags } from "vue-tags-component";

import VueSimpleSuggest from "vue-simple-suggest";
// import store from "@/store/store";

export default {
	name: "UpdateProviderForm",
	props: {
		chartParams: Object,
		isPercent: Boolean,
	},
	mixins: [utilsMixin, validatorMixin, dbFieldConvertor],
	components: {
		StarRating,
		VueSimpleSuggest,
		VxTooltip,
		VueTags,
	},
	data() {
		return {
			// USER OBJECT
			provider: Provider.getFormFields(),
			providerOld: Provider.getFormFields(),
			apiUrl: this.$store.state.backendApiUrl,
			// FORM SELECT OPTIONS
			expertiseOptions: [],
			providerTempOptions: [],
			providerTempOptionsOld: [],
			// Validator Objects
			ProviderValidationObjects: {
				nameValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "nameConstraint",
					required: true,
				},
				siretValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "siretConstraint",
					required: false,
				},
				commercial_idValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "commercial_idConstraint",
					required: true,
				},
				originValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "originConstraint",
					required: true,
				},
				websiteValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: false,
				},
				is_ecommerceValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "is_ecommerceConstraint",
					required: true,
				},
				statusValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "statusConstraint",
					required: false,
				},
			},
			validators: {},
			check: true,
			providerTypes: [],
			//Tags
			selectedTags: [],
			listDomaine: [],
			tagStyle: "z-index: 1 !important; overflow: auto;",
		};
	},
	created() {
		//  Load domain tags
		this.getDomain();
		//  Load provider types
		this.getProviderType();
		//  Load expertise options
		this.setServiceOptions();
		//  Load provider data
		this.getProvider();
	},
	methods: {
		getProvider() {
			this.$http
				.get(this.apiUrl + "providers/get/" + this.$route.params.providerId)
				.then((provider) => {
					this.provider = new Provider(provider.data[0]);
					this.providerOld = new Provider(provider.data[0]);
					// getting domain activity
					this.getActivityDomain();
					// getting expertise
					ProvidersServices.getServiceFromProvider(
						this.$route.params.providerId,
						(_, res) => {
							if (res) {
								for (let service of res.data) {
									let thisList = {
										text: service.name,
										value: service.service_id,
									};
									this.providerTempOptions.push(thisList);
									this.providerTempOptionsOld.push(thisList);
								}
							} else {
								this.$vs.notify({
									title: "Echec",
									text: "Le prestataire n'a pas de service.",
								});
							}
						}
					);
					// this.providerTempOptionsOld = this.getServiceFromProvider(this.$route.params.providerId)
				})
				.catch((err) => {
					this.$vs.notify({
						title: "Echec",
						text: "Le prestataire n'a pas été trouvé.",
					});
				});
		},
		getProviderType() {
			this.$http.get(this.apiUrl + "providers/get_types/").then((providerT) => {
				this.providerTypes = providerT.data;
			});
		},
		onTagAdded(tag) {
			if (this.selectedTags.indexOf(tag) < 0) this.selectedTags.push(tag);
		},

		onTagRemoved(tag) {
			this.selectedTags.splice(this.selectedTags.indexOf(tag), 1);
		},

		validateOne(val, name) {
			let value = val;
			value == 0 ? (value = "0") : "";

			let constname = "";

			switch (name) {
				case "society":
					value ? (value = String(val)) : (value = "");
					constname = "nameConstraint";
					break;
				case "activity_domain":
					constname = "statusConstraint";
					value = this.selectedTags.length;
					break;
				default:
					"";
			}

			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);

			if (
				this.validators[name].valid == false &&
				this.validators[name].errText == ""
			) {
				this.validators[name].errText = "Ce champ ne peut être vide.";
				if (name == "activity_domain" && value == 0)
					this.validators[name].errText = "Ce champ ne peut être vide.";
				if (name == "activity_domain" && value > 0)
					this.validators[name].errText = "";
			}

			this.validators[name].valid == false &&
			this.validators[name].errText !== ""
				? (this.check = false)
				: "";
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
			} else if (this.validators[name] && this.validators[name].errText == "") {
				return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
			} else {
				return "border: none !important; border-radius: none;";
			}
		},
		/**
		 * Send the data to tha API to create the new user
		 * If the form is successfully sent, the user is redirect to Providers.vue
		 */
		formSubmitted() {
			this.check = true;
			let fields = ["society", "activity_domain"];
			for (let i = 0; i < fields.length; i++) {
				let name = "";
				let value = this.provider[fields[i]];
				value == 0 ? (value = "0") : "";

				switch (fields[i]) {
					case "society":
						this.provider[fields[i]] ? (value = String(value)) : (value = "");
						name = "nameConstraint";
						break;
					case "activity_domain":
						name = "statusConstraint";
						value = this.selectedTags.length;
					default:
						"";
				}

				this.validators[fields[i]] = new Validator({ constraintName: name });
				this.validators[fields[i]].check(value);

				if (
					this.validators[fields[i]].valid == false &&
					this.validators[fields[i]].errText == ""
				) {
					this.validators[fields[i]].errText = "Ce champ ne peut être vide.";

					if (fields[i] == "activity_domain" && value == 0)
						this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
					if (fields[i] == "activity_domain" && value > 0)
						this.validators[fields[i]].errText = "";
				}

				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText !== ""
					? (this.check = false)
					: "";
				this.$forceUpdate();
			}
			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement.",
				});
				return false;
			} else {
				this.$http
					.post(this.apiUrl + "providers/edit", {
						id: this.$route.params.providerId,
						commentary: this.provider.commentary,
						status: this.provider.status,
						rate: this.provider.rate,
						society: this.provider.society,
						website: this.provider.website,
						tags: this.selectedTags,
						type: this.provider.type,
						refund: this.provider.refund,
					})
					.then((res) => {
						//console.log(res);
						//Modification des expertises
						let resultNew = this.providerTempOptions.filter(
							(service) => !this.providerTempOptionsOld.includes(service)
						);
						let resultDel = this.providerTempOptionsOld.filter(
							(service) => !this.providerTempOptions.includes(service)
						);
						for (let service of resultNew) {
							let newProvidersServices = new ProvidersServices({
								provider_id: this.$route.params.providerId,
								service_id: service.value,
							});
							//console.log(newProvidersServices);
							newProvidersServices.createProvidersService((err, res) => {
								if (err) console.log(err);
								if (res) {
									//console.log(res);
								}
							});
						}
						for (let service of resultDel) {
							ProvidersServices.deleteServiceForProvider(
								this.$route.params.providerId,
								service.value,
								(err, res) => {
									if (err) console.log(err);
									// if(res) //console.log(res);
								}
							);
						}
						/*
						 * Si service est dans ancien keep
						 *  Send a success notification to the user
						 */
						this.$vs.notify({
							title: "Succès",
							text: "Prestataire modifié avec succès.",
						});
						/*
						 * setTimeout( () =>{
						 * Send the user to the previous route
						 */
						this.$store.dispatch("getAllProviders");
						this.$store.dispatch("getAllServices");
						this.$router.go(-1);
						// }, 5000);
					})
					.catch((err) => {
						//console.log(err);
						this.$vs.notify({
							title: "Echec",
							text: "Le prestataire n'a pas été modifié..",
						});
					});
			}
		},

		/**
		 * Get all services options
		 */
		setServiceOptions() {
			Service.getAllServices((err, res) => {
				let final = [];
				for (let service of res) {
					final.push({ text: service.name, value: service.id });
				}
				this.expertiseOptions = final;
			});
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},

		getDomain() {
			this.$http
				.get(this.apiUrl + "tags/all")
				.then((res) => {
					let tmp = res.data;
					for (let tag of tmp) {
						tag["name"] = tag.tag_name;
						tag["slug"] = tag.tag_name;
						delete tag.tag_name;
					}
					this.listDomaine = tmp;
				})
				.catch((err) => console.log(err));
		},

		getActivityDomain() {
			this.$http
				.get(this.apiUrl + "tags/provider/" + this.$route.params.providerId)
				.then((res) => {
					let tmp = res.data;
					for (let tag of tmp) {
						tag["name"] = tag.tag_name;
						tag["slug"] = tag.tag_name;
						delete tag.tag_name;
					}
					this.selectedTags = tmp;
				})
				.catch((err) => console.log(err));
		},

		getExpertiseOptionsList() {
			return this.expertiseOptions;
		},
		selectExpertise(selectedExpertise) {
			//ADD TO TEMPORARY EXPERTISE LIST
			if (selectedExpertise != null) {
				if (this.providerTempOptions.length > 0) {
					if (
						this.providerTempOptions.filter(function (expertise) {
							return expertise.value === selectedExpertise.value;
						}).length > 0
					) {
						return false;
					}
					if (
						this.providerTempOptions.filter(function (expertise) {
							return expertise.value === selectedExpertise.value;
						}).length <= 0
					) {
						this.providerTempOptions.push(selectedExpertise);

						return true;
					}
				} else {
					this.providerTempOptions.push(selectedExpertise);
					return true;
				}
			}
			//console.log("selectExpertise");
		},
		boldenSuggestion(scope) {
			if (!scope) return scope;
			const { suggestion, query } = scope;
			let result = this.$refs.suggestComponent.displayProperty(suggestion);
			if (!query) return result;
			const texts = query.split(/[\s-_/\\|.]/gm).filter((t) => !!t) || [""];
			return result.replace(
				new RegExp("(.*?)(" + texts.join("|") + ")(.*?)", "gi"),
				"$1<b>$2</b>$3"
			);
		},

		removeChip(chip) {
			this.providerTempOptions.splice(
				this.providerTempOptions.indexOf(chip),
				1
			);
		},
		addNewExpertise() {
			let newService = new Service({
				name: this.provider.service_id,
			});
			newService.createService((err, res) => {
				if (err)
					if (res) {
						//console.log(err);
						this.setServiceOptions();
						this.selectExpertise({
							text: this.provider.service_id,
							value: res.data.id,
						});
					}
			});
			//console.log("addNewExpertise");
		},

		checkExpertiseInList() {
			if (this.provider.service_id != "") {
				return this.expertiseOptions.filter(
					(expertise) => expertise.text === this.provider.service_id
				).length > 0
					? false
					: true;
			} else {
				return false;
			}
		},

		/**
		 * Checks if Website is present and valid
		 */
		checkWebsite() {
			this.checkHandler(
				this.provider.website,
				this.ProviderValidationObjects.websiteValidationObject
			);
		},

		/**
		 * Check if all required fields for COntract are valid
		 * @return true if all are valid else return false if at least one is not valid
		 */
		checkAllFieldsError() {
			let fieldsErrorOk = true;

			Object.entries(this.ProviderValidationObjects).forEach((entry) => {
				const [key, value] = entry;
				if (value.notValid && fieldsErrorOk) {
					fieldsErrorOk = false;
				}
			});

			return fieldsErrorOk;
		},
	},
};
</script>

<style scoped>
@import "../../../assets/scss/vuexy/extraComponents/autocomplete.scss";

.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.bottom {
	align-self: flex-end;
}

.right_element {
	justify-content: flex-end;
}
</style>
